<template>
  <b-modal
    ref="upsModal"
    title="UPS Label Request"
    ok-title="Confirm"
    cancel-title="Cancel"
    ok-variant="danger"
    @shown="init"
    hide-footer
  >
    <div v-if="modalResponse">
      <div class="modal-body">
        <div class="row" v-if="modalResponse.status == 0">
          <div class="col-sm-12 col-xs-12">
            <p>
              <span style="color: red;">An error occured:</span>
              {{
                "(" +
                  modalResponse.errorCode +
                  ") " +
                  modalResponse.ErrorDescription
              }}
            </p>
            <p>
              <strong>You can either:</strong>
            </p>
            <ul>
              <li>Edit the shipping address and try again</li>
              <li>
                Ignore label creation for now but you would have to do it
                manually on the UPS website later.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="modal-footer" v-if="modalResponse.status == 0">
        <button type="button" class="btn btn-primary" @click="editShipping()">
          Edit Shipping
        </button>
        <button type="button" class="btn btn-warning" @click="ignoreUpsLabel()">
          Ignore Label Creation
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "ups-modal",
  props: ["upsResponse", "order"],
  data() {
    return {
      modalResponse: null
    };
  },
  methods: {
    editShipping() {
      this.hideModal();
      this.$parent.$parent.$refs.shippingDetails.edit();
    },
    init() {
      this.modalResponse = this.upsResponse;
    },
    ignoreUpsLabel() {
      //then shiporder
      this.$parent.shipOrder({ weight: 0 });
    },
    showModal() {
      this.$refs.upsModal.show();
    },
    hideModal() {
      this.$refs.upsModal.hide();
    }
  }
};
</script>
